export const TABS = {
    OVERVIEW: "overview",
    PROFILE: "profile",
    PAYMENTS: "payments",
    SUBSCRIPTIONS: "subscriptions",
} as const;

export type HomeTab = typeof TABS[keyof typeof TABS];

const HOME_TABS: readonly string[] = Object.values(TABS);

const isHomeTab = (tab: string): tab is HomeTab => HOME_TABS.includes(tab);

// Missing or unsupported tab values fall back to overview
export const resolveHomeTab = (tab?: string | null): HomeTab =>
    tab && isHomeTab(tab) ? tab : TABS.OVERVIEW;
